<template>
    <div class="d-flex flex-column">
        <FileUpload :action="action" :accept="accept" multiple
                    :badge-variant-is="getBadgeVariant"
                    @success="whenUploadSuccess"></FileUpload>
        <re-b-modal ref="uploadResult" header="Upload Result" centered>
            <div class="d-flex flex-column">
                <template v-for="(item,index) of Object.keys(groupedResult)">
                    <div :key="index" class="d-flex flex-column mt-2">
                        <h5>{{ item }}:</h5>
                        <div class="d-flex flex-wrap">
                            <template v-for="(failedMsg,i) of groupedResult[item]">
                                <b-badge :key="i" class="ml-1" variant="danger" style="font-size:0.7rem;">
                                    {{ failedMsg.name }}
                                    <template v-if="failedMsg.failedBy">
                                        >>{{ failedMsg.failedBy }}
                                    </template>
                                </b-badge>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </re-b-modal>
    </div>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import FileUpload from "@/components/common/inputs/FileUpload.vue";

export default {
    name: "FacesUpload",
    components: {FileUpload, ReBModal},
    computed: {
        headers() {
            return {
                'Authorization': localStorage['em_sso_token']
            }
        },
        groupedResult() {
            let result = {};
            for (let name in this.resultMap) {
                let item = this.resultMap[name];
                if (!item.isSucceed) {
                    let resultMsg = item.addResultMsg;
                    let failedMsg = {
                        name: name,
                        failedBy: item.failedBy
                    }
                    if (result[resultMsg]) {
                        result[resultMsg].push(failedMsg);
                    } else {
                        let tempList = [];
                        tempList.push(failedMsg);
                        result[resultMsg] = tempList;
                    }
                }
            }
            return result;
        },
    },
    data() {
        return {
            fileList: [], // 上传文件列表
            action: process.env.VUE_APP_EM_ADMIN_URL + "/emAclUser/face/upload",
            accept: '.jpg, .jpeg, .png',
            loading: false,

            resultMap: {},
            uploadHasSuccess: false
        }
    },
    methods: {
        whenUploadSuccess(response) {
            let result = response.data;
            if (result) {
                let hasFailed = false;
                let resultMap = {};
                for (let item of result) {
                    if (item.hasOwnProperty('faceFileName')) {
                        resultMap[item.faceFileName] = item;
                        if (!item.isSucceed) {
                            hasFailed = true;
                        } else {
                            this.uploadHasSuccess = true;
                        }
                    }
                }
                this.resultMap = resultMap;
                if (hasFailed) {
                    this.$refs.uploadResult.showModal();
                }
            }
        },
        getBadgeVariant(name) {
            let item = this.resultMap[name];
            if (item) {
                if (item.hasOwnProperty('isSucceed') && item.isSucceed) {
                    return 'success';
                } else {
                    return 'danger';
                }
            } else {
                return null;
            }
        },
    },
    beforeDestroy() {
        if (this.uploadHasSuccess) {
            this.$emit('needRefresh');
        }
    }
}
</script>

<style scoped>
.w-100 >>> .b-form-file .custom-file-label {
    width: 100%;
}

.w-100 >>> .custom-file-label {
    width: 100%;
}
</style>
